import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const TaskStore = {
  state: {
    tasks: [],
    task: {}
  },
  getters,
  mutations,
  actions
}

export default TaskStore